
import { filter, remplazarPorTildeASinTilde } from "../../../helpers/Buscador";
import { types } from "../../../types/types";



const initialState = {
    items: [],
    itemsAux: [],
    itemsPracticas: [],
    itemsPracticasAux: [],
    codNomAutor: [],
    loading: false,
};

export const ambCosegurosExternosReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.abmCosegurosExternosSuccess:
            return {
                ...state,
                loading: false,
                items: action.payload,
                itemsAux: action.payload
            };
        case types.abmBuscarCosegurosExternos:
            var itemsResults = state.itemsAux.filter(n => filter(remplazarPorTildeASinTilde(n.descripcion), remplazarPorTildeASinTilde(action.payload)))
            return {
                ...state,
                items: itemsResults
            };
        case types.abmPracticasCosegurosExternosSuccess:
            return {
                ...state,
                loading: false,
                itemsPracticas: action.payload,
                itemsPracticasAux: action.payload
            };
        case types.abmBuscarPracticasCosegurosExternos:
            var itemsResultsP = state.itemsPracticasAux.filter(n => filter(remplazarPorTildeASinTilde(n.descripcionNomenclador), remplazarPorTildeASinTilde(action.payload)))
            return {
                ...state,
                itemsPracticas: itemsResultsP
            };
        case types.abmCodNomAutorSuccess:
            return {
                ...state,
                loading: false,
                codNomAutor: action.payload,
            };
        default:
            return state;
    }
}